import { IconFlower } from "@tine/designsystem-icons/sharp";
import { cn } from "@tine/designsystem-utils";
import type { HTMLAttributes, PropsWithChildren } from "react";
import storeTheme from "../../../themes/theme";

type InformationBoxProps = {
   theme: "main" | "christmas" | "sustainable";
   title: string;
} & HTMLAttributes<HTMLDivElement>;

const InformationBox = ({ theme, title, className, children }: PropsWithChildren<InformationBoxProps>) => {
   const commonClasses = "flex flex-col rounded-lg gap-4 relative";

   // There is less padding-bottom because the richtext always ends with a <p> tag, which adds padding-bottom.
   const placementClasses = "max-w-2xl w-full mx-0 md:mx-auto px-6 pt-11 pb-4 md:px-12 md:pb-12 md:pt-16";

   const themeClasses = {
      main: "text-ink-brand-default bg-surface-tinted",
      christmas: [
         "text-ink-brand-inverted [&_label]:text-ink-brand-inverted [&_a]:text-ink-brand-inverted [&_svg]:fill-ink-brand-inverted",
         "bg-christmas pt-6 md:pt-6",
         "[&_button]:bg-christmasButton [&_button]:border-christmasButton [&_button]:text-ink-brand-inverted [&_button:hover]:bg-christmasButtonHover [&_button:hover]:border-christmasButtonHover"
      ].join(" "),
      sustainable: "text-ink-brand-default bg-surface-tip"
   }[theme];

   const flowersClasses = {
      main: "absolute left-0 -top-8",
      christmas: "",
      sustainable: "absolute left-0 -top-8"
   }[theme];

   return (
      <div className={cn(className, commonClasses, placementClasses, themeClasses)}>
         {storeTheme.storeId === "tinehandel" && (
            <div className={cn("w-full flex justify-center items-center", flowersClasses)}>
               <IconFlower height={32} width={32} />
               <IconFlower height={64} width={64} />
               <IconFlower height={32} width={32} />
            </div>
         )}

         <div
            className={cn({
               "pt-10": theme === "christmas" && storeTheme.storeId !== "tinehandel"
            })}
         >
            <h2 className="text-3xl text-center">{title}</h2>
            {children && (
               <>
                  <div className="flex justify-center w-full my-6">
                     <hr className="border w-11" />
                  </div>
                  <div>{children}</div>
               </>
            )}
         </div>
      </div>
   );
};

export default InformationBox;
